<template>
  <!--table paging v-bind="$props"  -->
  <div class="form-row align-items-center">
    <div class="col-auto">
      <div>total:{{ data.count }}</div>
    </div>
    <div class="col-auto">
      <b-btn variant="outline-info mr-2" class="btn-xs" @click="first()"><<</b-btn>
    </div>
    <div class="col-auto">
      <b-btn variant="outline-info mr-2" class="btn-xs" @click="prev()">Prev</b-btn>
    </div>
    <div class="col-auto">
      <div>{{ data.params.page }} / {{Math.ceil(data.count/data.params.limit)}}</div>
    </div>
    <div class="col-auto">
      <b-btn variant="outline-info mr-2" class="btn-xs" @click="next()">Next</b-btn>
    </div>
    <div class="col-auto">
      <b-btn variant="outline-info mr-2" class="btn-xs" @click="last()">>></b-btn>
    </div>
  </div>
</template>

<script>
import {reactive, ref, computed, watch, onMounted, onUnmounted} from '@vue/composition-api'

export default {
  props: {
    data: {},
  },
  setup(props, context) {
    return {
      ...actions(props.list, context)
    }
  }
}

function actions(list, context) {
  // 이전
  function prev() {
    context.emit('prev', {})
  }

  // 처음으로
  function first() {
    context.emit('first', {})
  }

  // 끝으로
  function last() {
    context.emit('last', {})
  }

  function next() {
    context.emit('next', {})
  }

  return {next, prev, first, last}
}
</script>
